<template>
    <div>
        <el-dialog v-if="dialogVisible" v-el-drag-dialog title="批量修改" :visible.sync="dialogVisible" width="900px">
            <span>
                <el-form>
                    <div style="width: 100%" class="el-table el-table--fit el-table--border">
                        <div class="el-table__body-wrapper">
                            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                                <tbody>
                                    <tr>
                                        <td class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'meetShape'" class="field">修改范围</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <ValidationProvider ref="ValidationProvider" v-slot="{ errors }"
                                                rules="required">
                                                <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]"
                                                    :class="{ 'invalid-field': errors[0] !== undefined }"
                                                    popper-class="error-popper-class" placement="right-start"
                                                    effect="dark">
                                                    <el-radio-group v-model="formData.type">
                                                        <el-radio :label="1">全部档案</el-radio>
                                                        <el-radio :label="2">按专业</el-radio>
                                                        <el-radio :label="3">按班级</el-radio>
                                                    </el-radio-group>
                                                </el-tooltip>
                                            </ValidationProvider>
                                        </td>
                                    </tr>
                                    <tr v-if="formData.type === 3">
                                        <td class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span class="field" v-field-lbl="'className'">班级</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <form-item key="class" ref="className" :field="{
                                                'defaultValue': null,
                                                'elementCanEdit': 1,
                                                'elementCssHeight': null,
                                                'elementCssWidth': null,
                                                'elementFormatter': null,
                                                'elementReadonly': 1,
                                                'elementType': 'input',
                                                'emptyMessage': '请选择班级',
                                                'errorMessage': null,
                                                'formTdAlign': 'text-left',
                                                'formTdColspan': 0,
                                                'isRequired': 1,
                                                'onClickEvent': '',
                                                'passenger': {},
                                                'propComment': '班级',
                                                'propName': 'className',
                                                'propType': 'String',
                                                'textFormatter': 'textfield',
                                                'valueMaxLength': null,
                                                'valueMinLength': null,
                                                'model': 'formData.className',
                                                'option': [],
                                                'dialog': 1,
                                                'dialogType': 'listpage',
                                                'dialogMultiple': false,
                                                'dialogListviewurl': 'school.clazz.list',
                                                'dialogTitle': '选择班级'
                                            }" :vo="formData" />
                                        </td>
                                    </tr>
                                    <tr v-if="formData.type === 2">
                                        <td class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span class="field" v-field-lbl="'majorName'">专业小类</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <form-item key="major" ref="majorName" :field="{
                                                'defaultValue': null,
                                                'elementCanEdit': 1,
                                                'elementCssHeight': null,
                                                'elementCssWidth': null,
                                                'elementFormatter': null,
                                                'elementReadonly': 1,
                                                'elementType': 'input',
                                                'emptyMessage': '请选择专业小类',
                                                'errorMessage': null,
                                                'formTdAlign': 'text-left',
                                                'formTdColspan': 0,
                                                'isRequired': 1,
                                                'onClickEvent': '',
                                                'passenger': {},
                                                'propComment': '专业小类',
                                                'propName': 'majorName',
                                                'propType': 'String',
                                                'textFormatter': 'textfield',
                                                'valueMaxLength': null,
                                                'valueMinLength': null,
                                                'model': 'formData.majorName',
                                                'option': [],
                                                'dialog': 1,
                                                'dialogType': 'listpage',
                                                'dialogMultiple': false,
                                                'dialogListviewurl': 'school.majors.list',
                                                'dialogTitle': '选择专业小类'
                                            }" :vo="formData" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="el-table__cell tdlbl tdw17" colspan="1"><span
                                                class="required">*</span>社保卡编号</td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <ValidationProvider ref="ValidationProvider" v-slot="{ errors }"
                                                name="社保卡编号" rules="required">
                                                <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]"
                                                    :class="{ 'invalid-field': errors[0] !== undefined }"
                                                    popper-class="error-popper-class" placement="right-start"
                                                    effect="dark">
                                                    <el-input v-model="formData.socialSecurityNumber"
                                                        name="socialSecurityNumber" placeholder="请输入社保卡编号" />
                                                </el-tooltip>
                                            </ValidationProvider>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="el-table__cell tdlbl tdw17" colspan="1"><span
                                                class="required">*</span>银行卡账号</td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <ValidationProvider ref="ValidationProvider" v-slot="{ errors }"
                                                name="银行卡账号" rules="required">
                                                <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]"
                                                    :class="{ 'invalid-field': errors[0] !== undefined }"
                                                    popper-class="error-popper-class" placement="right-start"
                                                    effect="dark">
                                                    <el-input v-model="formData.bankAccount" name="bankAccount"
                                                        placeholder="请输入银行卡账号" />
                                                </el-tooltip>
                                            </ValidationProvider>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmClick">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            loginUser: this.$store.getters.loginUser,
            formData: {
                className: '',
                majorName: '',
                type: 1,
                bankAccount: '',
                socialSecurityNumber: '',
                classId: '',
                majorSubcategoryId: ''
            },
        }
    },
    computed: {
    },
    created() {
        console.log('bathEditDialog--------')
        this.$bus.on('openBatchEditDialog', this.openBatchEditDialog)
    },
    beforeDestroy() {
        this.$bus.off('openBatchEditDialog', this.openBatchEditDialog)
    },
    methods: {
        openBatchEditDialog() {
            this.dialogVisible = true
        },
        confirmClick() {
            this.formValidate(() => {
                const type = this.formData.type
                const formData = {
                    bankAccount: this.formData.bankAccount,
                    socialSecurityNumber: this.formData.socialSecurityNumber,
                }
                if (type === 2) {
                    // 按专业
                    formData.majorSubcategoryId = this.formData.majorSubcategoryId
                } else if (type === 3) {
                    // 按班级
                    formData.classId = this.formData.classId
                }
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$http({
                    contentType: 'application/x-www-form-urlencoded',
                    url: `/xsgl/studentBasicInfo/updateBatch`,
                    method: 'PUT',
                    data: formData
                }).then(res => {
                    if (res.code === 'success') {
                        this.$message.success('保存成功')
                        this.dialogVisible = false
                    }
                }).finally(() => {
                    loading.close()
                })
            }, null, 1)
        },
        onSelectListpageRowCompleted: function (val, arr) {
            const item = val[0]
            const { name } = arr
            if (name === 'majorName') {
                this.formData.majorName = item.majorName
                this.formData.majorSubcategoryId = item.id
            } else if (name === 'className') {
                this.formData.className = item.className
                this.formData.classId = item.classId
            }
            console.log(item)
        },
    }
}
</script>

<style></style>
